import classNames from 'classnames/bind';
import { useEffect, useMemo, useState } from 'react';
import Button from 'ui/common/button/Button';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import { TWriteButtonStatus, WRITE_BUTTON_STATUS } from '../../../interface/recruit/IJD';
import { TSubmissionStatusType } from '../../../interface/recruit/IRecruitSetting';
import { formatDateWithDay } from '../../../util/dayUtil';
import style from './JDProcess.module.scss';
const cx = classNames.bind(style);

interface IProps {
  writeButtonStatus?: TWriteButtonStatus;
  submissionStatus: TSubmissionStatusType;
  startDateTime: string;
  endDateTime: string;
  handleClickApply?: () => void;
}

const JDProcessSubmitButton = ({
  writeButtonStatus,
  submissionStatus,
  startDateTime,
  endDateTime,
  handleClickApply,
}: IProps) => {
  const { multiLanguageText } = useMultiLanguage();
  const [applyButtonText, setApplyButtonText] = useState('지원하기');

  useEffect(() => {
    if (submissionStatus === 'PRE_SUBMISSION') {
      const startDateWithDayWithYear = formatDateWithDay(startDateTime, true, '접수 시작 시');
      setApplyButtonText(`${startDateWithDayWithYear.slice(5)} OPEN`);
      return;
    }
    setApplyButtonText(multiLanguageText('지원하기', 'Apply'));
  }, [submissionStatus, startDateTime, multiLanguageText]);

  const isTimeOver =
    submissionStatus === 'POST_SUBMISSION' ||
    (endDateTime !== null && new Date(endDateTime).getTime() < new Date().getTime());

  const checkIsApplyDisabled = useMemo(() => {
    if (submissionStatus === 'PRE_SUBMISSION') {
      return true;
    }
    return submissionStatus !== 'IN_SUBMISSION';
  }, [submissionStatus]);

  const isClosed = writeButtonStatus === WRITE_BUTTON_STATUS.CLOSE;

  if (isClosed) {
    return null;
  }

  if (isTimeOver) {
    return (
      <Button color={'dark'} size={'md'} className={cx('apply')} disabled>
        {multiLanguageText('접수 마감된 포지션입니다.', 'Closed')}
      </Button>
    );
  }

  return (
    <Button
      color={'teal'}
      size={'md'}
      className={cx('apply')}
      disabled={checkIsApplyDisabled}
      onClick={handleClickApply}
    >
      {applyButtonText}
    </Button>
  );
};

export default JDProcessSubmitButton;
